import script from "./DateComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DateComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__